import { useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { useApplicationContext } from 'shared/utils/applicationContext';
import clsx from 'clsx';

export const PreFooterNotice: React.FC = () => {
  const { config } = useApplicationContext();

  const device = useDeviceType();

  const textNotice = config.get<string[]>('b2b-marketing-smb-promo-frontend.preFooterNotice') || [];

  return (
    <div className={clsx(styles['container'], styles[device])}>
      {textNotice.map((row, index) => (
        <div className={styles['row']} key={index}>
          {row}
        </div>
      ))}
    </div>
  );
};
